import { Routes, Route } from "react-router-dom";
import HomePage from "../pages/hompage/HomePage";
import PrivateRoute from "../components/PrivateRouter";
import HomeAdmin from "../pages/Admin/HomeAdmin";
import ManageContent from "../pages/Admin/ManageContent";
import Login from "../pages/login/Login";
// Removed casino imports - folder deleted

// Removed NH imports - files don't exist
import CongThuc50 from "../pages/50-congthuc/50CongThuc";
import TongHopVideo from "../pages/tong-hop-video/TongHopVideo";
import VideoPlayer from "../pages/video-player/VideoPlayer";

const Approuter = () => {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/*"
        element={
          <PrivateRoute>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/admin" element={<HomeAdmin />} />
              <Route path="/admin/content" element={<ManageContent />} />


              {/* Removed NH routes - components don't exist */}
              
              <Route path="/50-congthuc" element={<CongThuc50 />} />
              <Route path="/tong-hop-video" element={<TongHopVideo />} />
              <Route path="/video/:videoId" element={<VideoPlayer />} />
            </Routes>
          </PrivateRoute>
        }
      />

    </Routes>
  );
};

export default Approuter;
